import { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { openMobileAppInfoModal } from 'components/shared/MobileAppInfo';
import { GENERAL_ERROR_MESSAGE } from 'constants/texts';
import { showErrorSnackbar } from 'hooks/useSnackbar';
import { showMobileInfoSelector } from 'store/app/selectors';
import { privacyPolicyDataSelector } from 'store/privacyPolicy/selectors';
import { axiosAuth } from 'utils/axios';
import logger from 'utils/logger';

import { GP_AUTH_SIGNIN_ROUTE, GP_AUTH_VERIFY_ROUTE } from '../../../GuestPortal/Routes/constants';
import { useGuestPortalRouteBuilder } from '../../../GuestPortal/Routes/functions';

export function useLookUp() {
  const history = useHistory();
  const { buildRoute } = useGuestPortalRouteBuilder();
  const { guestPortalId } = useParams<{ guestPortalId: string }>();
  const privacyPolicyData = useSelector(privacyPolicyDataSelector);
  const showMobileInfo = useSelector(showMobileInfoSelector);
  const lookup = useMutation(
    ({ email }: { email: string }) => axiosAuth.head('lookup_account', { params: { email } }),
    {
      onSuccess: (res, { email }) => {
        return history.push(buildRoute(GP_AUTH_SIGNIN_ROUTE, { email }));
      },
      onError: (err, { email }) => {
        if (Axios.isAxiosError(err)) {
          if (err.response?.status === 404) {
            return;
          }

          // user exists but is not verified
          if (err.response?.status === 401) {
            return history.push(buildRoute(GP_AUTH_VERIFY_ROUTE, { email }));
          }
        }

        logger.error(err);
        showErrorSnackbar(GENERAL_ERROR_MESSAGE);
      },
    },
  );
  const isNotFoundedEmail = Axios.isAxiosError(lookup.error) && lookup.error.response?.status === 404;

  useEffect(() => {
    if (privacyPolicyData && showMobileInfo) {
      openMobileAppInfoModal(`guest-portals/${guestPortalId}`, true);
    }
  }, [guestPortalId, privacyPolicyData, showMobileInfo]);

  return { lookup, isNotFoundedEmail };
}
